function pad(n: number): string {
  return n < 10 ? `0${n}` : String(n);
}

/** Whole days, hours and minutes left until `target`, clamped at zero. */
export function countdownParts(
  target: Date,
  now: Date,
): { days: number; hours: number; minutes: number } {
  const totalMinutes = Math.max(0, Math.floor((target.getTime() - now.getTime()) / 60_000));
  return {
    days: Math.floor(totalMinutes / 1440),
    hours: Math.floor((totalMinutes % 1440) / 60),
    minutes: totalMinutes % 60,
  };
}

/**
 * `HH:MM:SS` left until `target`, clamped at zero. Days fold into hours
 * ("26:05:09") because the streak timer never exceeds a day anyway.
 */
export function formatCountdown(target: Date, now: Date): string {
  const totalSeconds = Math.max(0, Math.floor((target.getTime() - now.getTime()) / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}

/**
 * Whole days left until `target`, and the rest of the last day as `HH:MM:SS`,
 * clamped at zero — for a timer that ticks by the second across several days
 * ("4d 23:12:45").
 */
export function countdownClock(target: Date, now: Date): { days: number; clock: string } {
  const totalSeconds = Math.max(0, Math.floor((target.getTime() - now.getTime()) / 1000));
  const rest = totalSeconds % 86_400;
  return {
    days: Math.floor(totalSeconds / 86_400),
    clock: `${pad(Math.floor(rest / 3600))}:${pad(Math.floor((rest % 3600) / 60))}:${pad(rest % 60)}`,
  };
}
